import React, { Component } from "react";
import { isMobile } from 'react-device-detect';

class Filter extends Component {
  constructor(props){
    super(props)
    this.state = {
      show_btn: false
    }
  }

  handleSubmit = (e) => {
      e.preventDefault();
      this.setState({
        show_btn: true
      })
  }

  close = () =>{
    this.props.closeFilter(true)
    this.setState({
      show_btn: false
    })
  }

  render() {
    return (
      <div className="content main-card mb-3 card">
        <div className={`card-body ${this.props.showMessage ? "pb-0" : null}`}>
              <form onSubmit={this.handleSubmit}>
                <div className="row">

                  <div className={`col-md-3 ${isMobile ? "mb-3" : ""}`}>
                    <label>Nombre de Usuario</label>
                    <input
                      className="form form-control"
                      type="text"
                      name="username"
                      placeholder="Nombre"
                      onChange={this.props.onChangeFilter}
                      value={this.props.formValuesFilter.username}
                    />
                  </div>

                  <div className={`col-md-3 ${isMobile ? "mb-3" : ""}`}>
                    <label>Correo Electronico</label>
                    <input
                      className="form form-control"
                      type="text"
                      name="second_email"
                      placeholder="Email"
                      onChange={this.props.onChangeFilter}
                      value={this.props.formValuesFilter.second_email}
                    />
                  </div>

                  <div className={`col-md-3 ${isMobile ? "mb-3" : ""}`}>
                    <label>Nombre</label>
                    <input
                      className="form form-control"
                      type="text"
                      name="first_name"
                      placeholder="Nombre"
                      onChange={this.props.onChangeFilter}
                      value={this.props.formValuesFilter.first_name}
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Cargos</label>
                    <select 
                      name="position_id" 
                      className="form form-control" 
                      value={this.props.formValuesFilter.position_id}  
                      onChange={this.props.onChangeFilter}
                    >
                        <option value="">Cargo</option>
                        {this.props.rols.map(item => (
                            <React.Fragment>
                                <option value={item.id}>{item.name}</option>
                            </React.Fragment>
                          ))
                        }
                    </select>
                  </div>

                  <div className="col-md-3 mt-3">
                    <label>Estado</label>
                    <select 
                      name="user_state" 
                      className="form form-control" 
                      value={this.props.formValuesFilter.user_state}  
                      onChange={this.props.onChangeFilter}
                    >
                        <option value="">Seleccione un estado</option>
                        <option value="true">Activo</option>
                        <option value="false">Inactivo</option>
                    </select>
                  </div>

                  {this.props.showMessage && (
                                    <div className="col-md-12 mt-3 text-center">
                                        <div className="alert alert-primary" role="alert">
                                            <b>No ha seleccionado una opción válida</b>
                                        </div>
                                    </div>
                                )}

                </div>
              </form>
        </div>
        <div className="card-footer">
              <button onClick={this.props.onClickFilter} className="btn-shadow btn btn-info float-right">Aplicar Filtro</button>
              <button onClick={this.props.cancelFilter} className="ml-2 btn btn-outline-danger">Cerrar filtros</button>
        </div>
      </div>
    );
  }
}
export default Filter;
